const el = Array.from(document.querySelectorAll(".blog h2"));

el.forEach(function(item, index) {
    if (index == 0) {
        item.style.paddingTop = 0;
    }
})

/*const contentBlocks = Array.from(document.querySelectorAll("#landingpage h2"));

if(window.location.pathname !== "/" && window.location.pathname !== "/ueber-uns/messen-events/get-nord-2022" && window.location.pathname !== "/ueber-uns/messen-events/get-nord-2022/gewinnspiel" && window.location.pathname !== "/ueber-uns/messen-events/get-nord-2022/gewinnspiel/teilnahmebedingungen" && window.location.pathname !== "/youtube-videos") {
    contentBlocks.forEach(function(item, index) {
        if (index == 0) {
            item.style.marginTop = "5rem";
        }
    })
}*/

/* const content_block = Array.from(document.querySelectorAll(".content-block"));

content_block.forEach((item, index) => {
    if (index !== 0 && item.previousElementSibling.classList.contains("content-widget")) {
        item.style.marginTop = "5rem";
    }
}) */
